export const _action_token = (value, input) => {
    return {type : 'SET_TOKEN', inputValue : value, inputType: input}
}

export const _action_user = (value, input) => {
    return {type : 'SET_USER', inputValue : value, inputType: input}
}

export const _action_authentication = (value, input) => {
    return {type : 'SET_AUTH', inputValue : value, inputType: input}
}